import { createFileRoute } from '@tanstack/react-router';

import { getSupportTicketsQueryOptions, SupportTicketDetailsLoading } from '@/_containers/support';
import { getContactQueryOptions } from '@/_pages/contacts/api-service';

export const Route = createFileRoute('/_private/contacts/_template/$id/support/$ticket_id')({
  loader: async (opts) => {
    const contactData = await opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id));
    await opts.context.queryClient.ensureQueryData(
      getSupportTicketsQueryOptions({ contactId: contactData.data.freshdesk?.toString() || '' })
    );
  },
  staticData: {
    pageTitle: 'Ticket Details',
    tabKey: 'contact/support/details',
    renderRightColumn: true,
    isViewOnly: true,
  },
  pendingComponent: SupportTicketDetailsLoading,
});
